import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

// import {

// } from '@fortawesome/pro-regular-svg-icons'

import {
  faArrowsAltH,
  faArrowsAltV,
  faBars,
  faCheckSquare,
  faChevronLeft,
  faChevronRight,
  faGripHorizontal,
  faGripLines,
  faGripVertical,
  faQuestionCircle,
  faSearch,
  faSortAmountDownAlt as faSortAmountDownAltSolid,
  faSortDown,
  faSortUp,
  faSquare,
  faStar,
  faTimes,
  faUser,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faCalendar,
  faCalendarPlus,
  faClock,
  faDownload,
  faFilePdf,
  faSignInAlt,
  faSignOutAlt,
  faSortAmountDownAlt as faSortAmountDownAltDuotone,
  faUsers,
} from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faArrowsAltH,
  faArrowsAltV,
  faBars,
  faCalendar,
  faCalendarPlus,
  faCheckSquare,
  faChevronLeft,
  faChevronRight,
  faClock,
  faDownload,
  faFilePdf,
  faGripHorizontal,
  faGripLines,
  faGripVertical,
  faQuestionCircle,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faSortAmountDownAltDuotone,
  faSortAmountDownAltSolid,
  faSortDown,
  faSortUp,
  faSquare,
  faStar,
  faTimes,
  faUser,
  faUsers,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
